import * as React from 'react';
import { Provider } from 'react-redux';

import { loadContainers } from '@eika-infrastruktur/render';

import { AvtaleProvider } from './avtaler/avtale-context';
import brukMock from './brukMock';
import { ConfigInterface, ConfigProvider } from './config';
import { defaultConfig } from './config/default-config-data';
import { configureStore } from './configure-store';
import { KundeProvider } from './kundeinfo/kunde-context';
import { AppRouter } from './router/router';

const store = configureStore();

require('./styles/main.scss');

if (brukMock()) {
    // eslint-disable-next-line global-require
    require('./mock/mock');
}

export const meldSkadeNamespace = 'forsikring.meld-skade';

const renderApp = (MyApp: React.ComponentType, namespace: string, appDefaultConfig: ConfigInterface) => {
    loadContainers(
        namespace,
        ({ config }) => (
            <div className="forsikring-meld-skade">
                <div className="sgw-content">
                    <Provider store={store}>
                        <ConfigProvider config={config}>
                            <KundeProvider>
                                <AvtaleProvider>
                                    <MyApp />
                                </AvtaleProvider>
                            </KundeProvider>
                        </ConfigProvider>
                    </Provider>
                </div>
            </div>
        ),
        appDefaultConfig,
    );
};

renderApp(AppRouter, meldSkadeNamespace, defaultConfig);
